import { ModalRef } from "mis-design-system/mis-modal";
import { MODAL_DATA_VAR } from "mis-design-system/mis-modal";
import { Component, Inject, OnInit } from "@angular/core";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { CookieService } from "../../../services/cookie.service";
import { IP_CONSENT_COOKIE_NAME } from "../../../constants/cookie.constants";
import { parseZone } from "moment";

@Component({
  selector: "mis-employee-web-exp-ip-consent",
  templateUrl: "./ip-consent.component.html",
  styleUrls: ["./ip-consent.component.scss"]
})
export class IpConsentComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  data;
  constructor(private modalRef: ModalRef, @Inject(MODAL_DATA_VAR) data, private cookieSvc: CookieService) {
    this.data = data;
  }

  ngOnInit(): void {}

  cancel(): void {
    this.modalRef.close();
  }

  confirm(): void {
    const date = parseZone().add(10, "years");
    this.cookieSvc.setCookie(IP_CONSENT_COOKIE_NAME, "yes", { expires: date.toDate().toUTCString(), Secure: true, SameSite: "Strict" });
    this.modalRef.close(true);
  }
}
